import { render, staticRenderFns } from "./vs-form-datepicker.vue?vue&type=template&id=b5a85868&scoped=true"
import script from "./vs-form-datepicker.vue?vue&type=script&lang=js"
export * from "./vs-form-datepicker.vue?vue&type=script&lang=js"
import style0 from "./vs-form-datepicker.vue?vue&type=style&index=0&id=b5a85868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a85868",
  null
  
)

export default component.exports